export type Region =
  | "Île-de-France"
  | "Auvergne-Rhône-Alpes"
  | "Provence-Alpes-Côte d'Azur"
  | "Nouvelle-Aquitaine"
  | "Occitanie"
  | "Hauts-de-France"
  | "Grand Est"
  | "Bretagne"
  | "Pays de la Loire"
  | "Normandie"
  | "Bourgogne-Franche-Comté"
  | "Centre-Val de Loire"
  | "Corse"
  | "Outre-Mer"
  | "National / Multi-sites";

export interface Formation {
  id: string;
  title: string;
  category: "BNSSA" | "MNS" | "Recyclage" | "Perfectionnement";
  organisme: string;
  location: string;
  region: Region;
  duration: string;
  price: string;
  /** ISO date (YYYY-MM-DD) — utilisée pour le tri chronologique */
  sessionDate: string;
  /** Libellé humain de la prochaine session */
  nextSession: string;
  description: string;
  programme: string[];
  certification: string;
  prerequisites: string[];
  color: "red" | "blue";
  /** Lien externe vers le site du centre de formation (à titre informatif) */
  website?: string;
  /** Téléphone de contact direct du centre */
  phone?: string;
  /** URL du logo de l'organisme de formation (optionnel) */
  logo?: string;
}

export const REGIONS: Region[] = [
  "Île-de-France",
  "Auvergne-Rhône-Alpes",
  "Provence-Alpes-Côte d'Azur",
  "Nouvelle-Aquitaine",
  "Occitanie",
  "Hauts-de-France",
  "Grand Est",
  "Bretagne",
  "Pays de la Loire",
  "Normandie",
  "Bourgogne-Franche-Comté",
  "Centre-Val de Loire",
  "Corse",
  "Outre-Mer",
  "National / Multi-sites",
];

export const formations: Formation[] = [
  {
    id: "f1",
    title: "Exemple de formation — Formation BNSSA",
    category: "BNSSA",
    organisme: "AquaForm Académie",
    location: "Paris (75)",
    region: "Île-de-France",
    duration: "180 heures (6 semaines)",
    price: "1 200 € à 1 800 €",
    sessionDate: "2025-03-03",
    nextSession: "Lundi 3 mars 2025",
    color: "red",
    description:
      "Le Brevet National de Sécurité et de Sauvetage Aquatique (BNSSA) est la qualification indispensable pour surveiller des bassins en tant qu'agent de sécurité aquatique. Cette formation intensive vous prépare aux techniques de sauvetage, aux gestes de premiers secours et à la réglementation en vigueur.",
    programme: [
      "Techniques de nage et sauvetage en eau calme",
      "Premiers secours — PSE1 et PSE2",
      "Réglementation des établissements aquatiques",
      "Gestion des situations d'urgence",
      "Pratique de plongée en apnée",
      "Épreuves de mise en situation",
    ],
    certification: "BNSSA — Ministère de l'Intérieur",
    prerequisites: [
      "Avoir 17 ans minimum",
      "Savoir nager (test de 200m)",
      "Aptitude médicale",
    ],
    website: "https://www.ffnatation.fr",
    phone: "01 41 83 87 70",
  },
  {
    id: "f3",
    title: "Exemple de formation — BPJEPS Activités Aquatiques et Natation (AAN)",
    category: "MNS",
    organisme: "Institut Nautique Démo",
    location: "Châtenay-Malabry (92)",
    region: "Île-de-France",
    duration: "12 mois (alternance)",
    price: "Financement CPF / OPCO",
    sessionDate: "2025-09-15",
    nextSession: "Lundi 15 septembre 2025",
    color: "blue",
    description:
      "Le BPJEPS AAN est le diplôme professionnel par excellence pour devenir Maître Nageur Sauveteur. Il vous qualifie pour enseigner la natation, encadrer des activités aquatiques et surveiller les bassins dans les établissements publics et privés.",
    programme: [
      "Enseignement de la natation tous publics",
      "Surveillance et sécurité aquatique",
      "Activités aquatiques (aquagym, aquabike, bébés nageurs)",
      "Gestion de groupe et pédagogie",
      "Réglementation du travail dans les métiers aquatiques",
      "Stages en alternance en établissements aquatiques",
    ],
    certification: "BPJEPS AAN — Ministère des Sports",
    prerequisites: [
      "Avoir 18 ans minimum",
      "PSE1 ou PSC1 en cours de validité",
      "Test de 50m nage libre chronométré",
      "Test d'apnée 15 mètres",
    ],
    website: "https://www.creps-idf.fr",
    phone: "01 41 87 18 00",
  },
  {
    id: "f5",
    title: "Exemple de formation — Perfectionnement Aquafitness & Aquabike",
    category: "Perfectionnement",
    organisme: "Studio AquaFit Démo",
    location: "Marseille (13)",
    region: "Provence-Alpes-Côte d'Azur",
    duration: "3 jours",
    price: "350 € à 500 €",
    sessionDate: "2025-02-24",
    nextSession: "Du lundi 24 au mercredi 26 février 2025",
    color: "blue",
    description:
      "Spécialisation pour les MNS souhaitant développer leurs compétences en aquafitness et aquabike. Formation complète incluant chorégraphies, musique et gestion de classe.",
    programme: [
      "Techniques aquafitness avancées",
      "Animation aquabike",
      "Création de séances originales",
      "Gestion de la musique et de la communication",
    ],
    certification: "Attestation de perfectionnement",
    prerequisites: ["BPJEPS AAN ou BEESAN", "Expérience en activités aquatiques"],
    phone: "04 91 22 44 66",
  },
  {
    id: "f7",
    title: "Exemple de formation — Formation BNSSA — Session Printemps",
    category: "BNSSA",
    organisme: "Litto'Sauvetage Démo",
    location: "Nice (06)",
    region: "Provence-Alpes-Côte d'Azur",
    duration: "8 semaines",
    price: "1 350 €",
    sessionDate: "2025-04-07",
    nextSession: "Lundi 7 avril 2025",
    color: "red",
    description:
      "Centre agréé proposant une formation BNSSA intensive avant la saison estivale, idéale pour intégrer une équipe de surveillance de plage ou de piscine sur la Côte d'Azur.",
    programme: [
      "200m nage libre + 100m sauvetage",
      "Plongée en apnée et remontée de mannequin",
      "PSE1 intégré",
      "Réglementation et fiches techniques",
    ],
    certification: "BNSSA — Ministère de l'Intérieur",
    prerequisites: ["17 ans minimum", "Aptitude médicale", "Test de natation initial"],
    phone: "04 93 21 87 65",
  },
  {
    id: "f11",
    title: "Exemple de formation — Recyclage PSE1 / PSE2",
    category: "Recyclage",
    organisme: "Secours Démo Formation",
    location: "Plusieurs sites en France",
    region: "National / Multi-sites",
    duration: "6 à 8 heures",
    price: "60 € à 90 €",
    sessionDate: "2025-02-08",
    nextSession: "Sessions mensuelles à partir du 8 février 2025",
    color: "red",
    description:
      "Formation continue annuelle obligatoire pour les titulaires du PSE1 ou PSE2. Sessions organisées chaque mois dans la majorité des départements.",
    programme: [
      "Révision des gestes de premiers secours",
      "Mises en situation d'équipe",
      "Actualités matériel et protocoles",
    ],
    certification: "Attestation de formation continue",
    prerequisites: ["PSE1 ou PSE2 valide"],
    website: "https://www.croix-rouge.fr",
    phone: "01 44 43 11 00",
  },
];
